import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabaseClient';

const UserManagement = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetch('/api/list-users')
      .then(res => res.json())
      .then(data => {
        console.log('Fetched users:', data);
        setUsers(data);
      })
      .catch(err => console.error('Failed to load users:', err));
  }, []);

  const fetchUsers = async () => {
    const { data, error } = await supabase.auth.admin.listUsers();
    if (error) {
      console.error('Failed to fetch users:', error.message);
    } else {
      const formatted = data.users.map((user) => ({
        id: user.id,
        name: user.user_metadata?.full_name || 'N/A',
        email: user.email,
        role: user.app_metadata?.role || 'user',
        status: user.banned_until ? 'inactive' : 'active',
      }));
      setUsers(formatted);
    }
  };

  const handlePromote = async (userId, currentRole) => {
    const {
      data: { session },
      error
    } = await supabase.auth.getSession();

    if (error || !session) {
      return alert('Could not get session token. Please log in again.');
    }

    const requesterToken = session.access_token;

    const res = await fetch('/api/promote-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, requesterToken }),
    });

    const result = await res.json();
    if (res.ok) fetchUsers();
    else alert(`Error: ${result.message}`);
  };

  const handleArchive = async (userId) => {
    const res = await fetch('/api/archive-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    });

    const result = await res.json();
    if (result.success) fetchUsers();
    else alert(`Error: ${result.message}`);
  };

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to permanently delete this user?')) return;

    const res = await fetch('/api/delete-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId }),
    });

    const result = await res.json();
    if (result.success) fetchUsers();
    else alert(`Error: ${result.message}`);
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">User Management</h1>

      <table className="min-w-full bg-white shadow rounded-lg overflow-hidden">
        <thead className="bg-gray-200">
          <tr>
            <th className="py-2 px-4 text-left">Name</th>
            <th className="py-2 px-4 text-left">Email</th>
            <th className="py-2 px-4 text-left">Role</th>
            <th className="py-2 px-4 text-left">Status</th>
            <th className="py-2 px-4">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-t">
              <td className="py-2 px-4">{user.name}</td>
              <td className="py-2 px-4">{user.email}</td>
              <td className="py-2 px-4 capitalize">{user.role}</td>
              <td className="py-2 px-4 capitalize">{user.status}</td>
              <td className="py-2 px-4 flex space-x-2 justify-center">
                <button
                  onClick={() => handlePromote(user.id, user.role)}
                  className={`px-2 py-1 rounded text-white ${user.role === 'admin' ? 'bg-purple-600 hover:bg-purple-700' : 'bg-blue-600 hover:bg-blue-700'}`}
                >
                  {user.role === 'admin' ? 'Demote' : 'Promote'}
                </button>
                <button
                  onClick={() => handleArchive(user.id)}
                  className="bg-yellow-600 text-white px-2 py-1 rounded hover:bg-yellow-700"
                >
                  Archive
                </button>
                <button
                  onClick={() => handleDelete(user.id)}
                  className="bg-red-600 text-white px-2 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserManagement;
